module.exports = __webpack_public_path__ + "img/left-arrow.99fdff45.svg";